import { ProductListInteractionType } from "../types";

// Experiments List
export const ONEPASS_EXPERIMENT_ID = "proj_onepass_q1_22";

// Recommender event_type
export const EVENT_RECOMMENDER_EVENT_TYPE = "recommended_bi";

// Product list interaction types
export const PRODUCT_LIST_INTERACTION_TYPES: Record<
  ProductListInteractionType,
  number
> = {
  click: 1,
  option: 2,
  addToCart: 3,
};

// OnePass
export const ONEPASS_CATEGORY = "OnePass";
export const ONEPASS_ACTION_MIGRATION_NUDGE = "Migration Nudge";
